export const LobbyData = [
  {
    color: "#B73642",
    image: "assets/lobby_images/my-dashboard.svg",
    link: "/home",
    id: 1,
  },
  {
    color: "#A9A9A9",
    image: "assets/lobby_images/insights.svg",
    link: "/insights",
    id: 2,
  },
  {
    color: "#258274",
    image: "assets/lobby_images/website.svg",
    link: "/website",
    id: 3,
  },
  {
    color: "#B06AB3",
    image: "assets/lobby_images/blog.svg",
    link: "/blog",
    id: 4,
  },
  {
    color: "#FFFFFF",
    image: null,
    link: "/",
    id: 5,
  },
  {
    color: "#0D6EBA",
    image: "assets/lobby_images/support.svg",
    link: "/support",
    id: 6,
  },
];
